// this util function provides a way to detect specific errors that is coming in as string literal (no status code)
const detect400BadRequest = (stringErrorData: string) => {
    if(stringErrorData.toUpperCase().includes("Bad Request".toUpperCase())){
        return true;
    } else {
        return false;
    }
}

export { detect400BadRequest };